import { FaEarthAsia } from "react-icons/fa6";
import {
  paydeer,
  payvendor,
  findeer,
  webhub,
  Frame6,
  Frame7,
  Frame8,
  Frame9,
  Frame1,
  Frame2,
  Frame3,
  Frame4,
  Frame5,
  FrameHover,
  FrameHover1,
  FrameHover2,
  FrameHover3,
  FrameHover4,
  FrameHover5,
  FrameHover6,
  FrameHover7,
  FrameHover8,
  app1,
  app2,
  app3,
  app4,
  d1,
  d2,
  d3,
  d4,
  d5,
  d6,
  avatar1,
  avatar3,
  avatar2,
  image1,
  image2,
  image3,
  journey1,
  journey2,
  journey3,
  journey4,
  careerTech1,
  careerTech2,
  careerTech3,
  careerTech4,
  careerTech5,
  careerTech6,
  careerTech7,
  careerTech8,
  careerTech9,
  salesFor1,
  salesFor2,
  salesFor3,
  salesFor4,
  salesFor5,
  salesFor6,
  salesFor7,
  salesFor8,
  salesFor9,
  salesForIcon1,
  salesForIcon2,
  salesForIcon3,
  salesForIcon4,
  salesForIcon5,
  web3Sales1,
  web3Sales2,
  web3Sales3,
  web3Sales4,
  web3Sales5,
  web3Sales6,
  web3Sales7,
  web3Sales8,
  html,
  react,
  mern,
  mean,
  angular,
  vue,
  ai_service1,
  ai_service6,
  ai_service5,
  ai_service4,
  ai_service3,
  ai_service2,
  ai_pro2,
  ai_pro1,
  ai_pro4,
  ai_pro5,
  ai_pro3,
  slideImd,
  solar3,
  solar1,
  solar2,
  slideBox1,
  slideBox2,
  slideBox3,
  slideBox4,
  bmImg1,
  bmImg2,
  bmImg3,
  bmImg4,
  bmImg5,
  bmImg6,
  Rectangle,
  uiUxSer1,
  uiUxSer2,
  iconMail,
  iconPhone,
  iconLinkedin,
  iconGoogle,
  iconPinterest,
  iconFacebook,
  iconInsta,
  tech1,
  tech2,
  tech3,
  tech4,
  tech5,
  fintechImg,
  location1,
  location2,
  softImg,
  softImg1,
  softImg2,
  softImg3,
  softImg4,
  softImg5,
  softProStep1,
  softProStep4,
  softProStep3,
  softProStep2,
  softProStep5,
  Soft_Tech2,
  Soft_Tech1,
  Soft_Tech3,
  Soft_Tech4,
  appIcon1,
  appIcon6,
  appIcon5,
  appIcon4,
  appIcon3,
  appIcon2,
  MobAppDevTech1,
  MobAppDevTech2,
  MobAppDevTech3,
  MobAppDevTech4,
  MobAppDevTech5,
  MobAppDevTech6,
  ai_app1,
  ai_app2,
  ai_app3,
  ai_app4,
  webPro1,
  webPro2,
  webPro3,
  webPro4,
  webServ1,
  webServ2,
  webServ3,
  webServ4,
  webServ5,
  webServ6,
  devopsSer1,
  devopsSer2,
  devopsSer3,
  devopsSer4,
  devopsSer5,
  devopsSer6,
  devOpSerBen1,
  devOpSerBen2,
  devOpSerBen3,
  devOpSerBen4,
  devOpSerBen5,
  devOpSerBen6,
  testimoIcon,
  ratingStar,
  testmoProfile,
  softImgHover,
  softImgHover1,
  softImgHover2,
  softImgHover3,
  softImgHover4,
  softImgHover5,
  techIcon1,
  techIcon2,
  techIcon3,
  techIcon4,
  techIcon5,
  techIcon6,
  techIcon7,
  techIcon8,
  techIcon9,
  techIcon10,
  techIcon11,
  techIcon12,
  techIcon13,
  techIcon14,
  techIcon15,
  techIcon16,
  cybdeerIcon1,
  cybdeerIcon2,
  cybdeerIcon3,
  cybdeerIcon4,
  location3,
  ourBusinessimg1,
  ourBusinessimg2,
  ourBusinessimg3,
  ourBusinessimg4,
  cardImg1,
  cardImg2,
  cardImg3,
  cardImg4,
  Mobilty,
  Frontend,
  Backend,
  AI,
  ML,
  CMS,
  benefitIcon1,
  benefitIcon2,
  benefitIcon3,
  benefitIcon4,
  webIcon1,
  webIcon2,
  webIcon3,
  webIcon4,
  webIcon5,
  d1_html,
  d2_reachjs,
  d3_mern,
  d4_mean,
  d5_angular,
  d6_vue,
  teamPerson1,
  teamPerson2,
  ds,
  f1,
  f2,
  f3,
  f4,
  f5,
  f6,
  b1,
  b2,
  b3,
  b4,
  b5,
  b6,
  a1,
  a2,
  a3,
  a4,
  a5,
  a6,
  m1,
  m2,
  m3,
  m4,
  da1,
  da2,
  da3,
  da4,
  da5,
  c1,
  c2,
  c3,
  c4,
  c5,
  slideImd1,
  slideImd2,
  slideImd3,
  slideImd4,
  slideImd5,
  slideImd6,
  slideImd7,
} from "./assetes";

export const navMenu = [
  {
    id: 1,
    name: "Our Company",
    submenu: [
      { name: "About Us", link: "/about" },
      { name: "Testimonials", link: "/testimonials" },
      { name: "Contact Us", link: "/contact-us" },
      { name: "Career", link: "/careers" },
    ],
  },
  {
    id: 2,
    name: "Services",
    submenu: [
      { name: "Software Development", link: "/software-development" },
      { name: "Business Modernization", link: "/business-modernization" },
      { name: "Salesforce", link: "/salesforce" },
      { name: "Mobile App Development", link: "/mobile-app-development" },
      { name: "Website Development", link: "/website-development" },
      { name: "UI UX Design", link: "/ui-ux-design" },
      { name: "AI Development", link: "/ai-development" },
      { name: "DevOps", link: "/devops" },
      { name: "On Demand", link: "/on-demand" },
    ],
  },
  {
    id: 3,
    name: "Industries",
    // submenu: [
    //   { name: "Fintech", link: "/fintech" },
    //   { name: "Healthcare", link: "/healthcare" },
    //   { name: "Agriculture", link: "/agriculture" },
    //   { name: "Real Estate", link: "/real-estate" },
    //   { name: "Ecommerce", link: "/ecommerce" },
    // ],
  },
  {
    id: 4,
    name: "Platform",
    submenu: [
      { name: "DevOps", link: "/devops" },
      { name: "Salesforce", link: "/salesforce" },
    ],
  },
];

export const trustArr = [paydeer, payvendor, findeer, webhub];

export const services = [
  {
    img: Frame1,
    hoverImg: FrameHover,
    title: "Mobile app creation",
    desc: "We create innovative, client-friendly mobile apps with a focus on cybersecurity and flexible solutions,turning your ideas into a reality.",
    link: 'mobile-app-development'
  },
  {
    img: Frame2,
    hoverImg: FrameHover1,
    title: "Software creation",
    desc: "Our expert software developers use advanced technology and cutting-edge tools to create well-crafted solutions that will benefit your company.",
    link: 'software-development'
  },
  {
    img: Frame3,
    hoverImg: FrameHover2,
    title: "AI creation",
    desc: "Our expert developers use advanced tools to create well-crafted software solutions that align with future trends, ensuring your company benefits from cutting-edge technology.",
    link: 'ai-development'

  },
  {
    img: Frame4,
    hoverImg: FrameHover3,
    title: "Website Development",
    desc: "We deliver exceptional websites with expert UX design, mobile-first responsiveness, high-quality content, fast loading speeds, strong SEO, robust security, and effective calls to action.",
    link: 'website-development'

  },
  {
    img: Frame5,
    hoverImg: FrameHover4,
    title: "DevOps",
    desc: "A combination of development and IT services, with the goal of shortening the software lifecycle and delivering high-quality software through our expert developers.",
    link: 'devops'

  },
  {
    img: Frame6,
    hoverImg: FrameHover5,
    title: "UX/UI Design ",
    desc: "For a better user experience, we create a superior UI with visual designs, interactive elements, and consistent layouts, all enhanced by AI and immersive technologies.",
    link: 'ui-ux-design'

  },
  {
    img: Frame7,
    hoverImg: FrameHover6,
    title: "Business modernization",
    desc: "You need to update your company technologies, services or products, and strategic approach to align with the future. We are ready to provide this business modernization service to help you achieve your future vision.",
    link: 'business-modernization'

  },
  {
    img: Frame8,
    hoverImg: FrameHover7,
    title: "Salesforce",
    desc: "Salesforce is a cloud-based CRM software that is helpful for all types of customer services, removing all the problems we have with traditional CRM.",
    link: 'salesforce'

  },
  {
    img: Frame9,
    hoverImg: FrameHover8,
    title: "On Demand ",
    desc: "Your choice, our responsibility” We provide custom on-demand services for various industries, from ride-hailing to streaming, with features that align with your vision and market demand.",
    link: '/'

  },
];

export const cybdeerProjects = [
  {
    title: "Experience matters for your projects",
    num: "10+",
    icon: cybdeerIcon1,
  },
  { title: "countries trusted customer", num: "40+", icon: cybdeerIcon1 },
  { title: "projects done by us", num: "1000+", icon: cybdeerIcon2 },
  { title: "client retention", num: "98%", icon: cybdeerIcon3 },
  { title: "global clients", num: "500+", icon: cybdeerIcon4 },
  { title: "Team", num: "100+", icon: cybdeerIcon4 },
];

export const apps = [app1, app2, app3, app4];

export const features = [
  { title: "Mobility", img: Mobilty },
  { title: "Frontend", img: Frontend },
  { title: "Backend", img: Backend },
  { title: "Artificial Intelligence", img: AI },
  { title: "Machine Learning", img: ML },
  { title: "Data Analytics", img: ds },
  { title: "CMS & E-Commerce", img: CMS },
];

export const contentData = {
  Mobility: [
    { title: "Swift", img: d1 },
    { title: "Xcode", img: d2 },
    { title: "Kotlin", img: d3 },
    { title: "Ionic", img: d4 },
    { title: "Xamarin", img: d5 },
    { title: "React Native", img: d6 },
  ],
  Frontend: [
    { title: "HTML", img: f1 },
    { title: "CSS", img: f2 },
    { title: "JavaScript", img: f3 },
    { title: "React.js", img: f4 },
    { title: "Angular", img: f5 },
    { title: "Vue.js", img: f6 },
  ],
  Backend: [
    { title: "Node.js", img: b1 },
    { title: "Python", img: b2 },
    { title: "Spring Boot", img: b3 },
    { title: "PHP (Laravel)", img: b4 },
    { title: "Ruby on Rails", img: b5 },
    { title: ".NET", img: b6 },
  ],
  "Artificial Intelligence": [
    { title: "Open AI", img: a1 },
    { title: "Meta", img: a2 },
    { title: "Hugging Face", img: a3 },
    { title: "Mistral AI", img: a4 },
    { title: "NLP", img: a5 },
    { title: "PyTorch", img: a6 },
  ],
  "Machine Learning": [
    { title: "Jupyter Notebook", img: m1 },
    { title: "PyTorch", img: m2 },
    { title: "Scikit-learn", img: m3 },
    { title: "TensorFlow", img: m4 },
  ],
  "Data Analytics": [
    { title: "Python", img: da1 },
    { title: "SQL", img: da2 },
    { title: "Spark", img: da3 },
    { title: "Power BI", img: da4 },
    { title: "Excel", img: da5 },
  ],
  "CMS & E-Commerce": [
    { title: "WordPress", img: c1 },
    { title: "Drupal", img: c2 },
    { title: "Joomla", img: c3 },
    { title: "Magento", img: c4 },
    { title: "Ghost", img: c5 },
  ],
};

export const features2 = [
  { title: "Swift", img: d1 },
  { title: "Xcode", img: d2 },
  { title: "Kotlin", img: d3 },
  { title: "Ionic", img: d4 },
  { title: "Xamarin", img: d5 },
  { title: "React Native", img: d6 },
];
export const featuresWeb = [
  { title: "CMS", img: Mobilty },
  { title: "Frontend", img: Frontend },
  { title: "Backend", img: Backend },
  { title: "Data Base ", img: AI },
  { title: "Hosting", img: ML },
  // {title: "CMS & E-Commerce", img: CMS},
];

export const features2Web = [
  { title: "HTML", img: d1_html },
  { title: "ReachJS", img: d2_reachjs },
  { title: "Mern Stack ", img: d3_mern },
  { title: "Mean Stack", img: d4_mean },
  { title: "Angular JS ", img: d5_angular },
  { title: "Vue.JS", img: d6_vue },
];

export const slider = [
  {
    img: avatar1,
    name: "Minal",
    role: "Product Manager",
    rating: 4.5,
    desc: "You are one of the best IT solution providers in India, offering excellent services that are a result of your forward-thinking ideas and innovation. This gives us the power to survive in a competitive AI environment, as your higher level of innovation allows you to solve our problems efficiently and on time.",
  },
  {
    img: avatar2,
    name: "Rahul Sharma",
    role: "Product Manager",
    rating: 4.5,
    desc: "We highly recommend Cybdeer as the best company in Jaipur for modern app development. Their expert team delivered the best mobile app development services, exceeding our expectations. With cutting-edge technology and a focus on user experience, they provide top-quality software solutions that truly drive business growth.",
  },
  {
    img: avatar3,
    name: "Maxin Will",
    role: "Product Manager",
    rating: 4.5,
    desc: "I have been eagerly waiting for this moment to express my satisfaction with their services. As one of the top software companies in Jaipur, they have helped us achieve more website traffic through their digital transformation services. This has significantly boosted our brand awareness. A huge thank you to the team at Cybdeer.  ",
  },
  {
    img: avatar2,
    name: "Shivam Sharma",
    role: "Product Manager",
    rating: 4.5,
    desc: "I have been eagerly waiting for this moment to express my satisfaction with their services. As one of the top software companies in Jaipur, they have helped us achieve more website traffic through their digital transformation services. This has significantly boosted our brand awareness. A huge thank you to the team at Cybdeer.  ",
  },
  {
    img: avatar1,
    name: "Sneha Patel",
    role: "CEO, Cybdeer",
    rating: 4.5,
    desc: "We highly recommend Cybdeer as the best company in Jaipur for modern app development. Their expert team delivered the best mobile app development services, exceeding our expectations. With cutting-edge technology and a focus on user experience, they provide top- quality software solutions that truly drive business growth.",
  },
];

export const blogs = [
  {
    image: image1,
    category: "Design",
    title: "UX review presentations",
    description:
      "How do you create compelling presentations that wow your colleagues and impress your managers wow your colleagues and your managers?  ",
    author: {
      avtar: avatar1,
      name: "Admin",
      date: "20 Jan 2025",
    },
  },
  {
    image: image2,
    category: "Product",
    title: "Migrating to Linear 101",
    description:
      "How do you create compelling presentations that wow your colleagues and impress your managers wow your colleagues and your managers?  ",
    author: {
      avtar: avatar3,
      name: "Admin",
      date: "19 Jan 2025",
    },
  },

  {
    image: image3,
    category: "Software Engineering",
    title: "Building your API Stack",
    description:
      "How do you create compelling presentations that wow your colleagues and impress your managers wow your colleagues and your managers?",
    author: {
      avtar: avatar2,
      name: "Admin",
      date: "18 Jan 2025",
    },
  },
];

export const techItems = [
  { name: "JavaScript", icon: techIcon1, active: false },
  { name: "CSS3", icon: techIcon2, active: true },
  { name: "HTML", icon: techIcon3, active: true },
  { name: "ReactJS", icon: techIcon4, active: true },
  { name: "Next.JS", icon: techIcon5, active: true },
  { name: "Svelte", icon: techIcon6, active: true },
  { name: "Angular Java Script", icon: techIcon7, active: true },
  { name: "Spring Boot", icon: techIcon8, active: false },
  { name: "Mean Stack", icon: techIcon9, active: false },
  { name: "Shopify", icon: techIcon10, active: true },
  { name: "Drupal", icon: techIcon11, active: true },
  { name: "HubSpot", icon: techIcon12, active: true },
  { name: "Mern Stack", icon: techIcon13, active: true },
  { name: "Laravel", icon: techIcon14, active: true },
  { name: "VueJS", icon: techIcon15, active: false },
  { name: "Blockchain", icon: techIcon16, active: false },
];

export const locations = [
  {
    img: location1,
    address:
      "2ND Foor, C-10, Chitrakoot Marg, Sector 9, Vaishali Nagar, Jaipur, Rajasthan 302021",
  },
  {
    img: location2,
    address:
      "Meydan Grandstand, 6th floor, Meydan Road, Nad AI Sheba, Dubai, U.A.E",
  },
  {
    img: location3,
    address: "#254 Vision Exchange 2 Venture Drive, Singapore 608526",
  },
];

export const footerLinks = [
  {
    title: "Services",
    items: [
      "iOS App Development",
      "Android App Development",
      "Software Development",
      "Ionic App Development",
      "Flutter App Development",
      "Angular Web Development",
    ],
  },
  {
    title: "Company",
    items: [
      "About",
      "Contact us",
      "Careers",
      "Our Team",
      "Life At Cybdeer",
      "Partnership",
      "Blog",
    ],
  },
  {
    title: "Industries",
    items: ["Healthcare", "Restaurant", "Finance", "Fintech", "On-Demand Apps"],
  },
];

export const reachUs = {
  title: "Reach Us",
  contacts: [
    {
      title: "Cybdeer@gmail.com",
      icon: iconMail,
      link: "https://mail.google.com/mail/?view=cm&fs=1&to=Cybdeer@gmail.com",
    },
    { title: "0987654321", icon: iconPhone, link: "tel:0987654321" },
  ],
  socials: [
    { icon: iconInsta, link: "https://www.instagram.com/accounts/login/" },
    { icon: iconFacebook, link: "https://www.facebook.com/" },
    { icon: iconLinkedin, link: "https://www.linkedin.com/login" },
    { icon: iconGoogle, link: "https://www.google.com/" },
    { icon: iconPinterest, link: "https://www.pinterest.com/login" },
  ],
};

export const journeys = [
  {
    year: "2016",
    description:
      "The company was established with a small recharge payment app and payment gateway by its two co-founders, Vinod Parihar and Kishan Lal.",
    image: journey4,
  },
  {
    year: "2017-2018",
    description:
      "Our formal registration was completed in 2017 and 2018, marking a significant milestone in our expansion of services.",
    image: journey2,
  },
  {
    year: "2019-2020",
    description:
      "we were prepared to offer services under a new name. This was followed by the establishment of four additional companies in 2020: Paydeer, PayVendor, Webhub zone, and Findeer.",
    image: journey3,
  },
  {
    year: "2021-2022",
    description:
      "We formally completed the registration of our four companies. By 2022, we are proud to have reached a significant milestone: a hundred crore  turnover.",
    image: journey4,
  }, {
    year: "2023-2024",
    description:
      " We began a new phase of expansion by entering the TSP and module API sector. We continued our global growth last year by establishing new offices in Singapore and Dubai.",
    image: journey1,
  },
];

export const jobs = [
  {
    title: "Frontend Developer",
    experience: "3 years minimum experience in ReactJS.",
    badges: ["Full Time", "Min 3 Years", "Indore, India"],
    img: careerTech1,
  },
  {
    title: "Manual QA",
    experience: "2 years minimum experience in testing.",
    badges: ["Full Time", "Min 2 Years", "Indore, India"],
    img: careerTech2,
  },
  {
    title: "MERN Stack Developer",
    experience: "3 years minimum experience in ReactJS.",
    badges: ["Full Time", "Min 3 Years", "Indore, India"],
    img: careerTech3,
  },
  {
    title: "Business Analyst - Post Sales",
    experience: "3 years minimum experience in ReactJS.",
    badges: ["Full Time", "Min 3 Years", "Indore, India"],
    img: careerTech4,
  },
  {
    title: "Business Analyst - Pre Sales",
    experience: "2 years minimum experience in ReactJS.",
    badges: ["Full Time", "Min 3 Years", "Indore, India"],
    img: careerTech5,
  },
  {
    title: "Graphic Designer",
    experience: "3 years minimum experience in ReactJS.",
    badges: ["Full Time", "Min 3 Years", "Indore, India"],
    img: careerTech6,
  },
  {
    title: "Digital Marketing Intern",
    experience: "3 years minimum experience in ReactJS.",
    badges: ["Full Time", "Min 3 Years", "Indore, India"],
    img: careerTech7,
  },
  {
    title: "SEO Specialist",
    experience: "3 years minimum experience in ReactJS.",
    badges: ["Full Time", "Min 3 Years", "Indore, India"],
    img: careerTech8,
  },
  {
    title: "Back Office Executive",
    experience: "3 years minimum experience in ReactJS.",
    badges: ["Full Time", "Min 3 Years", "Indore, India"],
    img: careerTech9,
  },
];

export const benefits = [
  {
    icon: benefitIcon1,
    text: "A friendly workforce spread across UK, Egypt, China, Europe, and India",
  },
  {
    icon: benefitIcon2,
    text: "A chance to have a healthy Work Life Balance.",
  },
  {
    icon: benefitIcon3,
    text: "Many opportunities to unleash Your Creative side",
  },
  {
    icon: benefitIcon4,
    text: "Our Philosophy... Play harder.",
  },
];

export const infoCards = [
  {
    title: "Who We Are ?",
    desc: "Cybdeer is a leading IT solutions company based in Jaipur, with over eight years of experience. We expanded our global footprint in 2022 by establishing offices in Dubai and Singapore.",
  },
  {
    title: "Where Do We Come From ?",
    desc: "In 2016, our founders, Vinod Parihar and Kishan Lal, established this company in Jaipur with some key features. Now, our company operates at a global level, providing expert services both domestically and internationally.",
  },
  {
    title: "What We Do ?",
    desc: "Our values are the principles that guide our decisions and define our culture. We are driven by a commitment to innovation, adaptability, transparency, integrity, excellence, quality, collaboration, and growth.",
  },
  {
    title: "How We Make Difference ?",
    desc: "To achieve your best growth, consider joining us. Our global vision, security-by-design, and true partnerships with punctual delivery are all backed by our experts, who have over eight years of experience in this field.",
  },
];

export const salesServices = [
  {
    id: 1,
    title: "Blockchain Platform Developmentt",
    img: salesFor1,
    desc: "Developing a new blockchain platform involves building a core protocol, consensus mechanism, network architecture, and smart contract engine to create a secure environment."
  },
  {
    id: 2,
    title: "Open Blockchain Solutions",
    img: salesFor2,
    desc: "Open blockchain solutions are public, permission less networks that build trust, foster innovation, and provide censorship resistance. Examples include Bitcoin and Polygon."
  },
  {
    id: 3,
    title: "Private Blockchain Development",
    img: salesFor3,
    desc: "A private blockchain is a permissioned type of blockchain controlled by an organization. It is useful for supply chain management, financial services, and voting systems."
  },
  {
    id: 4,
    title: "Blockchain Browser development",
    img: salesFor4,
    desc: "For a well-developed blockchain explorer, we offer features to view block and transaction details,track addresses, interact with smart contracts, and monitor network health."
  },
  {
    id: 5,
    title: "Blockchain Wallet Development",
    img: salesFor5,
    desc: "Blockchain wallet development creates secure digital tools for managing assets. These wallets provide key management, security features, and a user interface for cryptocurrencies."
  },
  {
    id: 6,
    title: "Blockchain Development",
    img: salesFor6,
    desc: "We provide blockchain development services to build trust, transparency, automation, and censorship resistance for your business using powerful frameworks."
  },
  {
    id: 7,
    title: "Enterprise Blockchain Development",
    img: salesFor7,
    desc: "Enterprise blockchain development builds secure, efficient systems by applying blockchain principles to enhance business trust, transparency, and growth."
  },
  {
    id: 8,
    title: "Custom Blockchain Development",
    img: salesFor8,
    desc: "At Cybdeer, we offer custom blockchain services tailored to your company’s type and size, ensuring a perfect fit with advanced features for optimal outcomes."
  },
  {
    id: 9,
    title: "Blockchain Integration",
    img: salesFor9,
    desc: "Blockchain integration helps incorporate blockchain technology, enhancing security, transparency, and efficiency to reduce costs and grow your business."
  },
];

export const SalesIndustary = [
  {
    title: "Requirement Analysis",
    icon: salesForIcon1,
    desc: "At Cybdeer, our blockchain analysis defines business goals, risks, stakeholder engagement, technical selection, and regulatory requirements.",
  },
  {
    title: "Model Selection",
    icon: salesForIcon2,
    desc: "Our developers select the type, consensus, smart contract, platform, architecture, and securitybest suited for your organization's success.",
  },
  {
    title: "Data Integration",
    icon: salesForIcon3,
    desc: "Our experts understand data sources, data mapping, smart contracts, APIs, and middleware for secure automation.",
  },
  {
    title: "Validation and Verification",
    icon: salesForIcon4,
    desc: "In this process, code review, functional, integration testing, compliance, simulation, user acceptance, and security testing occur.",
  },
  {
    title: "Support and Maintenance",
    icon: salesForIcon5,
    desc: "Monitoring and performance management, including security,  help fix big issues, ensuring secure alignment with goals.",
  },
];

export const web3services = [
  {
    id: 1,
    title: "AI Development",
    img: web3Sales1,
    desc: "Our AI-Web3 services enhance blockchain with intelligence and automation, offering security and impactful growth for your organization.",
  },
  {
    id: 2,
    title: "Metaverse Development",
    img: web3Sales2,
    desc: "Metaverse development creates new digital worlds, offering economic opportunities with enhanced security and transparency.",
  },
  {
    id: 3,
    title: "Web3 Development",
    img: web3Sales3,
    desc: "Web3 development creates a next-generation internet, removing Web2 limitations by building a user-centric, secure, and open system.",
  },
  {
    id: 4,
    title: "Crypto Exchange Development",
    img: web3Sales4,
    desc: "We are a digital asset platform where you can buy, sell, and trade cryptocurrencies, offering all types of crypto exchange development.",
  },
  {
    id: 5,
    title: "NFT Development",
    img: web3Sales5,
    desc: "NFTs are digital building blocks offering new economic models, true digital ownership, new revenue streams, and enhanced security for your organization.",
  },
  {
    id: 6,
    title: "Token Development",
    img: web3Sales6,
    desc: "We provide custom token development services with various features, which is helpful for your growth and security.",
  },
  {
    id: 7,
    title: "Metaverse AI Development",
    img: web3Sales7,
    desc: "Metaverse AI development builds, enhances, and manages virtual worlds, offering scalability, and new economic models for your business growth.",
  },
  {
    id: 8,
    title: "DApps Development",
    img: web3Sales8,
    desc: "DApps, on a decentralized network like blockchain, remove traditional app limitations, providing better data control and security.",
  },
];

export const techStacks = [
  { name: "HTML", img: html },
  { name: "ReactJS", img: react },
  { name: "Meren Stack", img: mern },
  { name: "Mean Stack", img: mean },
  { name: "Angular JS", img: angular },
  { name: "Vue.JS", img: vue },
];

export const Ai_Services = [
  {
    title: "AI MVP Development ",
    img: ai_service1,
    desc: "As a leading AI development services provider, Cybdeer offers AI Minimum Viable Product (MVP) development services that are helpful for reducing risk, improving cost efficiency, and enhancing AI models, all of which are good for your business."
  },
  {
    title: "Custom AI Model Development",
    img: ai_service2,
    desc: "Standard AI products often don&#39;t fit a company’s unique needs, so custom development is a great way for businesses to build the perfect solution to help them meet their goals and satisfy their customers."
  },
  {
    title: "AI Integration Services",
    img: ai_service3,
    desc: "We offer the best AI integration services for your company. Our solutions are designed to enhance customer satisfaction, improve scalability, boost efficiency and productivity, enable better decision-making, and reduce costs."
  },
  {
    title: "Enterprise AI Development",
    img: ai_service4,
    desc: "We provide custom enterprise AI development, offering the best AI solution for your large organization with a focus on scalability, security, governance, and integration. We offer not only development services, but also monitoring and maintenance."
  },
  {
    title: "Generative AI Development ",
    img: ai_service5,
    desc: "As one of the top generative AI development companies, we provide the best generative AI development services. We create different types of content, including text, images, video, and audio, for use in marketing, customer service, entertainment, and content creation."
  },
  {
    title: "Multi Agent System development ",
    img: ai_service6,
    desc: "With our multi-agent system development, we solve your problems by distributing parts of them to experts to achieve a single goal. Our systems are effective for solving complex and dynamic problems in areas like customer services, supply chain management, and financial trading."
  },
];

export const Ai_Process = [
  { title: "Discovery & Planning", img: ai_pro1 },
  { title: "Data Collection & Preparation", img: ai_pro2 },
  { title: "Model Development & Training", img: ai_pro3 },
  { title: "Deployment & Integrationion ", img: ai_pro4 },
  { title: "Monitoring & Maintenance", img: ai_pro5 },
];

export const Ai_Slide = [
  {
    title: "FinTech",
    desc: "Our fintech app development services provide a fully secure application with scalability and a future-forward vision. Our experienced developers will make your app more productive for you and your company’s future. We include key features in your fintech app such as robust security, a seamless user experience, personalization, real-time data analysis, and more. Don’t waste your time searching for fintech app development companies you are already in the right place, with a team that has all the qualities you need to develop your fintech application.",
    img: slideImd1,
  },
  {
    title: "Healthcare",
    desc: "Our healthcare software is designed for patients, doctors, staff, and hospitals. We create solutions that are secure, compliant, and intuitive, ensuring they are easy for all users to adopt. By keeping regulatory requirements in mind, we offer a full range of healthcare software, from Electronic Health Records and telemedicine platforms to remote patient monitoring and hospital management systems. Our development process prioritizes compliance, security, interoperability, and scalability.",
    img: slideImd2,
  },
  {
    title: "Real Estate",
    desc: "In the modern world, the real estate industry is going digital to upgrade businesses, increase sales, and enhance transparency and brand awareness. We, as a top software development company, give you the best features you need for all users—including customers, owners, government agencies, and staff. Our solutions include virtual/augmented reality, digital documents, marketing automation, and data analytics. Before starting, we research technologies, trends, and costs to ensure the best results.",
    img: slideImd3,
  },
  {
    title: "Ecommerce",
    desc: "Our services focus on developing digital platforms and tools for businesses that operate both online and in physical retail locations. Our goal is to streamline sales and provide valuable market insights while ensuring a secure and user-friendly experience. We develop a comprehensive suite of solutions including online stores, marketplaces, Point-of-Sale (POS) systems, CRM, and inventory/order management—to modernize your business and help you remain competitive.",
    img: slideImd4,
  }, {
    title: "Logistic ",
    desc: "We develop software designed to be the digital backbone of your business, enabling you to transition to modern management strategies. Our solutions streamline warehouse, transportation, fleet, and order management by leveraging technologies such as the Internet of Things, artificial intelligence, cloud computing, GPS, and data analytics. This helps your organization grow and thrive in a competitive environment by making it more efficient, responsive, and competitive.",
    img: slideImd5,
  }, {
    title: "Education",
    desc: "EdTech is a rapidly growing industry, projected to reach $348 billion, driven by the demand for online learning and upskilling. By leveraging technologies like AI, AR/VR, and gamification, digital education platforms are essential for staying competitive, offering flexible, and engaging learning experiences to meet modern demands.",
    img: slideImd6,
  }, {
    title: "On Demand",
    desc: "Our on-demand services stand out because we offer a future-forward vision, delivering real-time solutions for various industries like transport, food, and healthcare. We prioritize your growth and flexibility by providing services that are not only in demand but also cost-effective and delivered efficiently, helping you scale with ease.",
    img: slideImd7,
  },
];

export const UXUI_Slide = [
  {
    title: "FinTech",
    desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    img: fintechImg,
  },
  {
    title: "FinTech",
    desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    img: fintechImg,
  },
  {
    title: "FinTech",
    desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    img: fintechImg,
  },
];

export const Ai_services2 = [
  {
    image: solar1,
    title: "Artificial Intelligence & Machine Learning Frameworks",
    description:
      "AI app development is helpful for solving complex tasks using tools like TensorFlow, PyTorch, Keras, LangChain, and many more.",
  },
  {
    image: solar2,
    title: "Natural Language Processing (NLP)",
    description:
      "NLP is about generating human language form computers to understand, with applications like chatbots, virtual assistants, email spam filtering, text summarization, and social media monitoring.",
  },
  {
    image: solar3,
    title: "Cloud & Deployment Platforms",
    description:
      "Computer vision is about teaching computers to interpret and understand visuals, including image classification, object tracking, image segmentation, and OCR.",
  },
];

export const Ai_SecurityCards = [
  {
    image: slideBox1,
    title: "We Implement Secure design Principle",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut.",
  },
  {
    image: slideBox2,
    title: "Data Security & Privacy",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut.",
  },
  {
    image: slideBox3,
    title: "Robot Authentication and Access Control",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut.",
  },
  {
    image: slideBox4,
    title: "Complaints and Standards",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut.",
  },
  {
    image: slideBox2,
    title: "Data Security & Privacy",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut.",
  },
];

export const BusinessServices = [
  {
    title: "Digital Transformation Consulting",
    desc: "We provide guidance to organizations on what is a good fit for their business, considering current trends and their future vision. This guidance is helpful for enhancing customer engagement and creating new business models.",
  },
  {
    title: "Process Automation",
    desc: "It involves using automation technologies rather than manual tasks, which help save time, decrease expenses, and reduce human errors with the use of technologies like AI, machine learning, and workflow automation.",
  },
  {
    title: "Future-Ready Solutions",
    desc: "Adopting future trends and moving forward is essential for every organization. Without doing so, we are unable to survive in a competitive market or achieve scalability for our organization.",
  },
  {
    title: "Cybersecurity Modernization",
    desc: "Cybersecurity modernization is about an organization’s security and involves following some principles, using advanced technologies, and investing in employee training, all of which are helpful for securing the organization and its data.",
  }, 

  {
    title: "Cloud Transformation",
    desc: "Cloud transformation helps your business improve efficiency, reduce costs, and increase agility. At Cybdeer, we provide these solutions, from strategic assessment and planning to the optimization of cloud resources.",
  },

  {
    title: "Data Analytics and Business Intelligencen",
    desc: "Data analytics and business intelligence are helpful for using data in the best way, which leads to improved decision-making, growth, and the ability to predict future trends. We provide comprehensive services, from data collection to prescriptive analytics.",
  },
];

export const processSteps = [
  {
    icon: Rectangle,
    title: "Assessment & Strategy",
    description:
      "We Prioritize Your Privacy With End-To-End Encryption, Ensuring That.",
  },
  {
    icon: Rectangle,
    title: "Technology Upgrade",
    description:
      "We Prioritize Your Privacy With End-To-End Encryption, Ensuring That.",
  },
  {
    icon: Rectangle,
    title: "Process Automation",
    description:
      "We Prioritize Your Privacy With End-To-End Encryption, Ensuring That.",
  },
  {
    icon: Rectangle,
    title: "Digital Experience Enhancement",
    description:
      "We Prioritize Your Privacy With End-To-End Encryption, Ensuring That.",
  },
  {
    icon: Rectangle,
    title: "Ongoing Support & Scaling",
    description:
      "We Prioritize Your Privacy With End-To-End Encryption, Ensuring That.",
  },
];
export const BusinessTechnologies = [
  {
    title: "Cloud Platforms & Containerization",
    description:
      "We use cloud services and packaged technologies to determine the best fit for your industry.",
    icon: bmImg1,
  },
  {
    title: "Artificial Intelligence & Machine Learning",
    description:
      "It involves not only automation but also analyzing data, making predictions, and adopting modern technologies.",
    icon: bmImg2,
  },
  {
    title: "API Management & Integration Tools",
    description:
      "It is about securing your data by following rules and protocols within modern digital services.",
    icon: bmImg3,
  },
  {
    title: "Automation Tools",
    description:
      "Using automation helps in reducing costs and human errors, which leads to better improvement and scalability for your organization.",
    icon: bmImg4,
  },
  {
    title: "Modern Web & App Technologies",
    description:
      "Cybdeer is a future-vision company that focuses on modern technologies that suit your organization’s industry.",
    icon: bmImg5,
  },
  {
    title: "Document AI & RPA for Process Automation",
    description:
      "Document AI reads invoices or forms, and after that, RPA is helpful for the part that is based on rules.",
    icon: bmImg6,
  },
];

export const BusinessMethodologies = [
  {
    title: "Agile Development Methodology",
    description:
      "Agile methodologies are about breaking down large projects into smaller parts, which makes it easier to find problems in business modernization.",
  },
  {
    title: "DevOps",
    description:
      "DevOps is a combination of practices that focuses on speed and quality through automation, continuous improvement, and collaboration.",
  },
  {
    title: "Design Thinking",
    description:
      "For problem-solving, design thinking provides us with the framework and innovations needed to survive in this competitive market.",
  },
  {
    title: "Lean Six Sigma",
    description:
      "The goal is to improve efficiency and reduce defects in a process, while also minimizing errors and solving problems in lean six sigma methods.",
  },
];

export const UiUxData = [
  {
    reverse: false,
    icon: uiUxSer1,
    title: "User Research & Analysis",
    desc: "Understanding target audience behavior and needs. Competitor analysis and industry benchmarking. Creating detailed user personas and journey maps",
  },
  {
    reverse: false,
    icon: uiUxSer2,
    title: "Wireframing & Prototyping",
    desc: "Understanding target audience behavior and needs. Competitor analysis and industry benchmarking. Creating detailed user personas and journey maps",
  },
  {
    reverse: false,
    icon: uiUxSer1,
    title: "UI Design",
    desc: "Understanding target audience behavior and needs. Competitor analysis and industry benchmarking. Creating detailed user personas and journey maps",
  },
  {
    reverse: true,
    icon: uiUxSer2,
    title: "UX Design & Strategy",
    desc: "Understanding target audience behavior and needs. Competitor analysis and industry benchmarking. Creating detailed user personas and journey maps",
  },
  {
    reverse: true,
    icon: uiUxSer1,
    title: "Design System & Branding",
    desc: "Understanding target audience behavior and needs. Competitor analysis and industry benchmarking. Creating detailed user personas and journey maps",
  },
  {
    reverse: true,
    icon: uiUxSer2,
    title: "Usability Testing",
    desc: "Understanding target audience behavior and needs. Competitor analysis and industry benchmarking. Creating detailed user personas and journey maps",
  },
];

export const tech_work = [
  { title: "Figma", img: tech1 },
  { title: "Adobe XD", img: tech2 },
  { title: "Photoshop", img: tech3 },
  { title: "Illustrator", img: tech4 },
  { title: "Prototpie", img: tech5 },
];

export const UiUxProcessSteps = [
  {
    title: "Empathize",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry",
  },
  {
    title: "Define",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry",
  },
  {
    title: "Ideate",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry",
  },
  {
    title: "Design",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry",
  },
  {
    title: "Test",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry",
  },
];

export const softwareServices = [
  {
    icon: softImg,
    hoverIcon: softImgHover,
    title: "Software Development Consulting",
    description:
      "Our experienced developers are ready to optimize your workflows, and deliver high-quality software solutions for your business. Unlike others who only aim to sell their products, we focus on your needs.",
  },
  {
    icon: softImg1,
    hoverIcon: softImgHover1,
    title: "Custom Software Development",
    description:
      "We provide software development services that combine advanced technologies and industry experience, ensuring you receive a tailored, future-ready software solution.",
  },
  {
    icon: softImg2,
    hoverIcon: softImgHover2,
    title: "Enterprise Software Development",
    description:
      "Enterprise software development solves complexity, security, and integration challenges for large organizations, addressing needs across multiple departments and users.",
  },
  {
    icon: softImg3,
    hoverIcon: softImgHover3,
    title: "AI Software Development",
    description:
      "To enhance efficiency, accuracy, and innovation, we must adopt AI software development. This fusion of human creativity and AI delivers the best outcome with a future-forward vision.",
  },
  {
    icon: softImg4,
    hoverIcon: softImgHover4,
    title: "Custom CRM Development",
    description:
      "Every business faces unique complexities. We offer custom CRM solutions, with tailored functionality, to help you overcome these challenges and boost your sales.",
  },
  {
    icon: softImg5,
    hoverIcon: softImgHover5,
    title: "API Development",
    description:
      "API development is the process of designing, developing, testing, and maintaining APIs, which helps enable faster development, scalability, and new revenue streams in these modern businesses.",
  },
];

export const softwareProcessSteps = [
  {
    icon: softProStep1,
    title: "Planning & Analysis",
    description:
      "The initial phase of our process involves a thorough consultation with stakeholders to understand your business objectives and requirements. This enables us to accurately define the project scope before planning a tailored solution.",
  },
  {
    icon: softProStep2,
    title: "UI UX / Architecture Design",
    description:
      "UI and UX design are crucial for a better user experience. While UI focuses on the visual design and layout of the software, UX is about the user’s feeling and overall journey. Our goal is to make the product intuitive, efficient, and enjoyable.",
  },
  {
    icon: softProStep3,
    title: "Agile Development",
    description:
      "Agile development is a smarter approach to building software, offering flexibility, continuous improvement, and close collaboration. It is crucial for continuous development, adapting to changes, and enhancing customer collaboration.",
  },
  {
    icon: softProStep4,
    title: "Validation and Verification/ Testing",
    description:
      "As one of our most important steps for ensuring a high-quality product, we focus on both verification and validation. Verification helps us catch bugs and errors, while validation ensures the product fulfils customer needs.",
  },
  {
    icon: softProStep5,
    title: "Software Development",
    description:
      "As the final step in software development, our expert developers create high-quality and innovativesoftware tailored to the modern world. After researching every aspect of your business, our experts use their deep understanding of programming languages and frameworks to boost your business with their experience.",
  },
];

export const technologies = [
  {
    title: "Artificial Intelligence",
    icon: Soft_Tech1,
    description:
      "To improve efficiency and innovation, our developers use AI's subfields like machine learning to create future-ready solutions.",
  },
  {
    title: "Data Analytics",
    icon: Soft_Tech2,
    description:
      "By collecting and analyzing your data, we gain insights that lead to key benefits, including better decision-making, reduced costs.",
  },
  {
    title: "Cloud",
    icon: Soft_Tech3,
    description:
      "we provide the best cloud services, including IaaS, PaaS, and SaaS, and enhanced security for your innovative ideas.",
  },
  {
    title: "Blockchain Software",
    icon: Soft_Tech4,
    description:
      "As a blockchain developer, we provide custom software solutions to enhance business security, trust, efficiency, and automation.",
  },
];

export const appDevelopmentServices = [
  {
    id: 1,
    title: "Custom App Development",
    description:
      "Our top-tier mobile app developers are prepared to propel your business forward. Combining expert knowledge with a future-oriented vision, we will ensure your business is equipped to succeed in today’s competitive landscape. By thoroughly understanding your specific needs, we offer custom mobile application development services tailored to all types of businesses.",
    icon: appIcon1,
  },
  {
    id: 2,
    title: "React Native App Development",
    description:
      "Our app development leverages React Native, offering key features such as native-like performance, faster updates, and enhanced value for our customers. Our expert developers utilize React Native to deliver a consistent and seamless experience across both iOS and Android platforms, ensuring a great user experience regardless of the device.",
    icon: appIcon2,
  },
  {
    id: 3,
    title: "Flutter App Development",
    description:
      "To deliver a powerful combination of business advantages and a high-quality product. Flutters cost effectiveness and accelerated development process, combined with a superior user experience and excellent performance, make it a premier choice. A key benefit of using Flutter is its future-proof vision, which allows your app to be expanded in the future without the need for a complete rebuild.",
    icon: appIcon3,
  },
  {
    id: 4,
    title: "Android App Development",
    description:
      "As an app development service, we offer native Android app development. We build custom Android apps for our clients with features that set us apart, such as punctuality, quality work, flexibility, and a future-forward vision. We provide all the key features you need in your app to achieve a five-star rating from your users.",
    icon: appIcon4,
  },
  {
    id: 5,
    title: "IOS App Development",
    description:
      "As iOS app users, we understand the need for key features like a native feel, high performance, a responsive and easy-to-navigate design, timely updates, and strong security and privacy. With all of these user-desired features, we are here to solve your iOS app development problems on time and with full flexibility.",
    icon: appIcon5,
  },
  {
    id: 6,
    title: "IONIC App Development",
    description:
      "Our developers are ready to provide you with expert hybrid app development services. Our solutions are built with key features like platform consistency, widespread accessibility, a web-first approach, and a familiar user interface. Experience our commitment to fast development and timely updates try us once to save a significant amount of your time.",
    icon: appIcon6,
  },
];

export const mobApptechnologies = [
  {
    id: 1,
    title: "Artificial Intelligence",
    description:
      "We all know how important AI is. AI is becoming an integral part of every website, we lack a future-forward business vision. This can negatively affect our business, as we will be unable to survive in a market.",
    icon: MobAppDevTech1,
  },
  {
    id: 2,
    title: "Internet Of Things (IOT)",
    description:
      "It is the simple connection of your physical objects with sensors, automation, artificial intelligence. This technology is incredibly helpful for businesses, faster product. we are focused on leveraging IoT to significantly improve your customers experience.",
    icon: MobAppDevTech2,
  },
  {
    id: 3,
    title: "BlockChain",
    description:
      "Blockchain is a chain of connected systems that secures your database. Including enhanced security and transparency, and new business models. This technology gives your business a future-forward vision and provides a significant overall advantage.",
    icon: MobAppDevTech3,
  },
  {
    id: 4,
    title: "Cloud",
    description:
      "Cloud services are non-physical services provided by a third party. We offer all types of cloud-based services, including SaaS. Having the best cloud services they are cost-effective, and fully secure for your business, helping you grow in the global market.",
    icon: MobAppDevTech4,
  },
  {
    id: 5,
    title: "AR/VR",
    description:
      "We offer AR and VR services to enhance your business. Our VR solutions provide total immersion in a completely digital environment using specialized hardware. These services are highly impactful for your business in various environments.",
    icon: MobAppDevTech5,
  },
  {
    id: 6,
    title: "MetaVerse",
    description:
      "We offer AR and VR services to enhance your business. Our VR solutions provide total immersion in a completely digital environment using specialized hardware, making them more accessible and interactive.",
    icon: MobAppDevTech6,
  },
];

export const aiMobFeatures = [
  {
    icon: ai_app1,
    title: "Adaptable method",
    description: "We are defined by our adaptability, flexibility, multi-disciplinary skills, and creative problem-solving.",
  },
  {
    icon: ai_app2,
    title: "Client Support",
    description: "Our main goal is to support our clients by building relationships that drive revenue and ensure a moother user experience.",
  },
  {
    icon: ai_app3,
    title: "Secure app building",
    description: "We adhere to security regulations such as GDPR, CCPA, CPRA, and PCI DSS, ensuring data protection and privacy.",
  },
  {
    icon: ai_app4,
    title: "Solutions and frameworks used by us",
    description: "The best app development, we begin by analyzing platforms and technologies.",
  },
];

export const WebProcessSteps = [
  {
    id: 1,
    title: "Business Analysis",
    icon: webPro1,
    description: "For better business scalability, analysis is important.",
  },
  {
    id: 2,
    title: "UI/UX Designing",
    icon: webPro2,
    description: "With our APIs, we create the best-fitting UI/UX for your industry.",
  },
  {
    id: 3,
    title: "Launch",
    icon: webPro3,
    description: "We provide an overview before launching so that we are aware of the functionality.",
  },
  {
    id: 4,
    title: "Maintenance & Support",
    icon: webPro4,
    description: "Maintenance and updates are the last and most crucial step.",
  },
];

export const webDevServices = [
  {
    id: 1,
    title: "Custom Website Design & Development",
    icon: webServ1,
    description:
      "Our membership management software provides full automation of membership renewals and payments",
  },
  {
    id: 2,
    title: "E-commerce Development",
    icon: webServ2,
    description:
      "Our membership management software provides full automation of membership renewals and payments",
  },
  {
    id: 3,
    title: "Portfolio & Business Websites",
    icon: webServ3,
    description:
      "Our membership management software provides full automation of membership renewals and payments",
  },
  {
    id: 4,
    title: "We Implement Secure design Principle",
    icon: webServ4,
    description:
      "Our membership management software provides full automation of membership renewals and payments",
  },
  {
    id: 5,
    title: "CMS Development For development",
    icon: webServ5,
    description:
      "Our membership management software provides full automation of membership renewals and payments",
  },
  {
    id: 6,
    title: "Maintenance & Support",
    icon: webServ6,
    description:
      "Our membership management software provides full automation of membership renewals and payments",
  },
];

export const devOpsServices = [
  {
    id: 1,
    title: "DevOps Consulting",
    description:
      "We guide you on the best DevOps services to fuel your digital growth, improving your journey in this competitive market.",
    icon: devopsSer1,
  },
  {
    id: 2,
    title: "DevOps Automation",
    description:
      "To succeed in software development and IT operations, you must automate your tasks with DevOps automation instead of relying on manual processes.",
    icon: devopsSer2,
  },
  {
    id: 3,
    title: "DevOps Staffing",
    description:
      "DevOps staffing is the solution for the challenge of finding, hiring, and managing professionals, offering benefits like cost efficiency and the ability to focus on your core business.",
    icon: devopsSer3,
  },
  {
    id: 4,
    title: "IT Infrastructure and Implementation",
    description:
      "To ensure better scalability, reliability, security, efficiency, and compliance, we create a complete IT ecosystem and implement it for your business.",
    icon: devopsSer4,
  },
  {
    id: 5,
    title: "DevOps Configuration Management",
    description:
      "DevOps Configuration Management automates processes, improving your business’s efficiency, speed, consistency, version control, auditability, and disaster recovery.",
    icon: devopsSer5,
  },
  {
    id: 6,
    title: "Code Inspection and Integration",
    description:
      "To build a high-quality, reliable application, our process protects your app from bugs, improves security, and ensures a fully functional system.",
    icon: devopsSer6,
  },
];

export const benefitsDevops = [
  {
    id: 1,
    title: "Experienced DevOps Developers",
    description:
      "At Cybdeer, our DevOps experts have over 8 years of experience, providing beneficial services and advice that matter for your business.",
    image: devOpSerBen1,
  },
  {
    id: 2,
    title: "Cost-efficient services",
    description:
      "We provide the best services with minimal investment for a superior outcome. By reducing costs, our aim is to deliver excellent DevOps services to everyone and make them aware of the benefits of using Cybdeer’s solutions.",
    image: devOpSerBen2,
  },
  {
    id: 3,
    title: "Reliable project timelines",
    description:
      "In modern business models, predictability is a key element for forecasting timelines, costs, quality, and resources, ensuring better outcomes.",
    image: devOpSerBen3,
  },
  {
    id: 4,
    title: "Incremental development/ Agile framework",
    description:
      "We use an Agile framework in software development that provides numerous benefits for your business, including flexibility, collaboration, reduced risk, improved quality, and increased customer satisfaction.",
    image: devOpSerBen4,
  },

  {
    id: 5,
    title: "Monitoring",
    description:
      "We believe that making a service is only half the job. We also continuously monitor it to catch any issues that may occur, ensuring that even if something goes wrong, we can fix it promptly.",
    image: devOpSerBen6,
  }
  ,
  {
    id: 6,
    title: "Complicated service rollout",
    description:
      "We operate in complex environments, but the complexity does not concern us. Our dedicated and experienced developers have the expertise to deliver complex solutions.",
    image: devOpSerBen5,
  },
];

export const testimonialsData = [
  {
    id: 1,
    text: "“The team at Cybdeer is incredibly knowledgeable and responsive. They not only solved our complex network issues but also provided a stable and reliable solution that has prevented any further downtime. Their expertise is unmatched.”",
    name: "Jane Cooper",
    role: "President of Sales",
    avatar: testmoProfile,
    quote: testimoIcon,
    stars: ratingStar,
  },
  {
    id: 2,
    text: "“We feel like Cybdeer is a true partner, not just a vendor. Their communication is excellent, and they always go the extra mile to ensure we understand the process and are completely satisfied. The personalized support we’ve received has been outstanding.”",
    name: "Jane Cooper",
    role: "President of Sales",
    avatar: testmoProfile,
    quote: testimoIcon,
    stars: ratingStar,
  },
  {
    id: 3,
    text: "“Since we partnered with Cybdeer for our IT support, our systems have been more stable and secure than ever. Their proactive monitoring and quick response times have given us complete peace of mind. Their support team is a pleasure to work with.”",
    name: "Jane Cooper",
    role: "President of Sales",
    avatar: testmoProfile,
    quote: testimoIcon,
    stars: ratingStar,
  },
  {
    id: 4,
    text: "“The team at Cybdeer was instrumental in developing our custom software. They were agile, communicated clearly throughout the project, and delivered a high-quality product that perfectly matched our specifications. The platform has significantly improved our workflow.”",
    name: "Jane Cooper",
    role: "President of Sales",
    avatar: testmoProfile,
    quote: testimoIcon,
    stars: ratingStar,
  },
  {
    id: 5,
    text: "“Partnering with Cybdeer for our software development was a game-changer. They helped us launch our new platform three weeks ahead of schedule, resulting in a 25% increase in user engagement within the first quarter. Their work directly impacted our bottom line.”",
    name: "Jane Cooper",
    role: "President of Sales",
    avatar: testmoProfile,
    quote: testimoIcon,
    stars: ratingStar,
  },
  {
    id: 6,
    text: "Cybdeer brought our mobile app vision to life! The UX/UI design is intuitive and the final product has flawless performance across iOS and Android. They were instrumental in the solution architecture, and their responsiveness to feedback was exceptional. The post-launch support has been reliable, quickly resolving minor bugs. Highly recommend for any new product development.",
    name: "Jane Cooper",
    role: "President of Sales",
    avatar: testmoProfile,
    quote: testimoIcon,
    stars: ratingStar,
  },
];

export const sliderDataMobApp = [
  {
    id: 1,
    title: "FinTech",
    desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
    img: fintechImg,
  },
  {
    id: 2,
    title: "Healthcare",
    desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
    img: fintechImg,
  },
  {
    id: 3,
    title: "E-commerce",
    desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
    img: fintechImg,
  },
  {
    id: 4,
    title: "Education",
    img: fintechImg,
    desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
  },
];

export const ourBusiness = [
  {
    id: 1,
    image: ourBusinessimg1,
    cardIcon: cardImg1,
    description:
      "We offer solutions for your online payments, allowing for secure transfers from websites to payment processors. We provide both & pay-in & pay-out services with all types of payment gateways, including hosted payment gateways, direct post, and API hosted. Our vendor payment solution is beneficial for your business because it increases efficiency, reduces costs, enhances security, and improves scalability and control, all of which are helpful for us. Our mission is to connect with organizations to help them with salary distribution.",
  },
  {
    id: 2,
    image: ourBusinessimg2,
    cardIcon: cardImg2,
    description:
      "Paydeer is a fintech company that operates on a B2B model with the goal of making bill payments and ticket booking easier. It provides a wide range of services, including Aadhaar-enabled payment systems, recharges, insurance, and e-tax services, as well as utility bill payments. These custom solutions are designed to best suit your organization, helping with your growth through digital measures, security, and AI customer services, which in turn offers convenience, efficiency, and automation.",
  },
  {
    id: 3,
    image: ourBusinessimg3,
    cardIcon: cardImg3,
    description:
      "We are a credit loan services provider company that works in a B2C model, offering all types of loans based on security and repayment structure. We have all the qualities you need for your credit loan, including transparency, clarity, favorable loan products, excellent customer service and support, responsible lending practices, robust technology, and security. We are regulated by the RBI, and we offer fair interest rates and full security. We also ensure that our services are accessible on mobile and that they take into account the borrower's ability to repay.",
  },
  {
    id: 4,
    image: ourBusinessimg4,
    cardIcon: cardImg4,
    description:
      "We help you establish your digital footprint with our expert digital marketing and e-commerce services. Our solutions offer global reach, measurable results, personalization, and cost-effectiveness, leading to an improved ROI. We offer a full suite of digital marketing services, including SEO, SEM, PPC, content marketing, SMM, email marketing, affiliate marketing, video marketing, and mobile marketing. Our e-commerce services cover platform and storefront development, payment solutions, logistics, customer support, and more.",
  },
];

export const webFeatures = [
  {
    id: 1,
    title: "Mobile-friendly & responsive design",
    icon: webIcon1,
    description:
      "Our websites are designed to work perfectly on all devices and screen sizes.",
  },
  {
    id: 2,
    title: "SEO-optimized structure",
    icon: webIcon2,
    description:
      "Built with search engine optimization in mind for better visibility.",
  },
  {
    id: 3,
    title: "Fast loading & performance-focused",
    icon: webIcon3,
    description:
      "Optimized for speed and performance to provide the best user experience.",
  },
  {
    id: 4,
    title: "Clean, modern UI/UX",
    icon: webIcon4,
    description:
      "Contemporary design that engages users and drives conversions.",
  },
  {
    id: 5,
    title: "Tailored to your business goals",
    icon: webIcon5,
    description:
      "Customized solutions that align with your specific business objectives.",
  },
];

export const teamData = [
  {
    id: 1,
    img: teamPerson1,
    role: "Creative Director",
    name: "RAHUL SHARMA",
    description:
      "A visionary with a passion for aesthetics and storytelling. Rahul shapes the visual language behind everything we do.",
  },
  {
    id: 2,
    img: teamPerson2,
    role: "Lead Developer",
    name: "PRIYA PATEL",
    description:
      "A technical expert who brings innovative solutions to life. Priya ensures our digital experiences are seamless and powerful.",
  },
  {
    id: 3,
    img: teamPerson1,
    role: "UX Designer",
    name: "ARJUN SINGH",
    description:
      "A creative mind focused on user experience. Arjun designs interfaces that are both beautiful and intuitive.",
  },
  {
    id: 4,
    img: teamPerson2,
    role: "Marketing Manager",
    name: "SOPHIA CHEN",
    description:
      "A strategic thinker who connects brands with their audiences. Sophia drives our marketing initiatives forward.",
  },
  {
    id: 5,
    img: teamPerson1,
    role: "Project Manager",
    name: "MARCUS JOHNSON",
    description:
      "An organized leader who keeps projects on track. Marcus ensures timely delivery and quality outcomes.",
  },
  {
    id: 6,
    img: teamPerson2,
    role: "Content Writer",
    name: "EMMA WILSON",
    description:
      "A wordsmith who crafts compelling narratives. Emma creates content that resonates with our audience.",
  },
  {
    id: 7,
    img: teamPerson1,
    role: "Frontend Developer",
    name: "DAVID KIM",
    description:
      "A frontend specialist who builds responsive interfaces. David creates smooth user experiences across all devices.",
  },
  {
    id: 8,
    img: teamPerson2,
    role: "Backend Developer",
    name: "LISA GARCIA",
    description:
      "A backend expert who builds robust systems. Lisa ensures our applications are scalable and secure.",
  },
  {
    id: 9,
    img: teamPerson1,
    role: "Quality Assurance",
    name: "JAMES BROWN",
    description:
      "A detail-oriented tester who ensures quality. James meticulously tests every feature before release.",
  },
];

// export const industries = [
//   {
//     id: 1,
//     title: "Fintech Software Development",
//     description:
//       "With over 8 years of experience in the field, Cybdeer's expertise is a valuable asset for your organization. We develop fintech software that is secure, scalable, compliant, and user-friendly. By leveraging APIs, cloud computing, AI, and machine learning, we deliver customized features and ensure a superior outcome, following a clear development process from research to deployment.",
//     icon: <FaCreditCard className="w-6 h-6" />,
//   },
//   {
//     id: 2,
//     title: "HealthCare Software Development Services",
//     description:
//       "With over 8 years of experience in the field, Cybdeer's expertise is a valuable asset for your organization. We develop healthcare software that is secure, scalable, compliant, and user-friendly. By leveraging APIs, cloud computing, AI, and machine learning, we deliver customized features and ensure a superior outcome, following a clear development process from research to deployment.",
//     icon: <FaHeartbeat className="w-6 h-6" />,
//   },
//   {
//     id: 3,
//     title: "Logistic Software Development Services",
//     description:
//       "With over 8 years of experience in the field, Cybdeer's expertise is a valuable asset for your organization. We develop logistics software that is secure, scalable, compliant, and user-friendly. By leveraging APIs, cloud computing, AI, and machine learning, we deliver customized features and ensure a superior outcome, following a clear development process from research to deployment.",
//     icon: <FaBuilding className="w-6 h-6" />,
//   },
//   {
//     id: 4,
//     title: "E-commerce Software Development",
//     description:
//       "With over 8 years of experience in the field, Cybdeer's expertise is a valuable asset for your organization. We develop e-commerce software that is secure, scalable, compliant, and user-friendly. By leveraging APIs, cloud computing, AI, and machine learning, we deliver customized features and ensure a superior outcome, following a clear development process from research to deployment.",
//     icon: <FaShoppingCart className="w-6 h-6" />,
//   },
//   {
//     id: 5,
//     title: "Education Software Development",
//     description:
//       "With over 8 years of experience in the field, Cybdeer's expertise is a valuable asset for your organization. We develop education software that is secure, scalable, compliant, and user-friendly. By leveraging APIs, cloud computing, AI, and machine learning, we deliver customized features and ensure a superior outcome, following a clear development process from research to deployment.",
//     icon: <FaGraduationCap className="w-6 h-6" />,
//   },
//   {
//     id: 6,
//     title: "Manufacturing Software Development",
//     description:
//       "With over 8 years of experience in the field, Cybdeer's expertise is a valuable asset for your organization. We develop manufacturing software that is secure, scalable, compliant, and user-friendly. By leveraging APIs, cloud computing, AI, and machine learning, we deliver customized features and ensure a superior outcome, following a clear development process from research to deployment.",
//     icon: <FaIndustry className="w-6 h-6" />,
//   },
// ];

